import styled, { css } from 'styled-components';

import BackgroundImage from '@pkg/assets/images/v2/pods/background.jpg';
import BackgroundImageMobile from '@pkg/assets/images/v2/pods/background_mobile.jpg';
import { styledReset } from '@pkg/primitives';

import { tokens } from './tokens';

export const pageFrameBase = css`
    display: grid;
    justify-content: center;
    grid-auto-flow: column;
    flex: 0 0 auto;
    padding: var(--yat_exp-page-padding);

    @media (min-width: ${({ theme }) => theme.breakpoints.tabletSmall}) {
        position: fixed;
        left: 0;
        right: 0;
    }
`;

export const InvitePageWrapper = styled.div`
    ${styledReset.borderBox};
`;

// Simply importing that styled-component causes the app to break.
// We should elevate this to a more shareable location anyways.
export const GroupsBackground = styled.div`
    width: 100%;
    min-height: 100vh;
    background-image: url(${BackgroundImageMobile});
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;

    @media (min-width: ${(props) => props.theme.breakpoints.mobile}) {
        background-image: url(${BackgroundImage});
    }
`;

export const Interior = styled.div`
    --yat_exp-page-padding: ${tokens.page.padding.mobile}px;
    --yat_header-brand-height: ${tokens.brand.height.mobile}px;

    display: flex;
    flex-direction: column;
    min-height: 100vh;

    @media (min-width: ${({ theme }) => theme.breakpoints.tabletSmall}) {
        --yat_exp-page-padding: ${tokens.page.padding.desktop}px;
        --yat_header-brand-height: ${tokens.brand.height.desktop}px;
    }
`;
